import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';

export const isOtherSiteError = (error) => error?.response?.status === 409 && error.response.data?.detail?.code === 'VEHICLE_OTHER_SITE';
export const errorDetailText = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' ? detail : detail?.message || fallback;
};

export const OtherSiteVehicleConfirm = ({ pending, onCancel, onConfirm, busy }) => (
  <AlertDialog open={Boolean(pending)} onOpenChange={open => !open && !busy && onCancel()}>
    <AlertDialogContent data-testid="other-site-vehicle-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Véhicule d'un autre site</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="space-y-2 text-sm">
            <p className="font-medium text-slate-900" data-testid="other-site-vehicle-message">{pending?.detail?.message || "Ce véhicule est rattaché à un autre site de livraison. Confirmez-vous vouloir l'utiliser ?"}</p>
            <p data-testid="other-site-vehicle-plate">Véhicule : <strong>{pending?.plate}</strong></p>
            <p data-testid="other-site-vehicle-sites">Site du véhicule : <strong>{pending?.detail?.vehicle_site_name}</strong> · Votre site de livraison : <strong>{pending?.detail?.employee_site_name}</strong></p>
            <p className="text-slate-600">Vous pourrez l'utiliser immédiatement. Les administrateurs seront informés pour mettre à jour le rattachement du véhicule.</p>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid="other-site-vehicle-cancel">Annuler</AlertDialogCancel>
        <AlertDialogAction disabled={busy} onClick={onConfirm} data-testid="other-site-vehicle-confirm">{busy ? 'Enregistrement...' : 'Oui, utiliser ce véhicule'}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
